<template>
    <div>
        <div
            class="terms"
            :class="{'has-error': error }"
        >
            <DSSwitches
                v-model="order.data.value.terms"
                type="checkbox"
                :options="terms"
            />
            <a class="terms-link" href="https://helmisimpukka.fi/ennakkotilaus/ennakko-ja-ryhmatilauksen-ehdot" target="_Blank">{{ $i18n.t('readTerms') }}</a>
        </div>
        <p v-if="error" class="validation-error">{{ $i18n.t('groupOrderForm.agreeTerms') }}</p>
    </div>
</template>
<script setup>
import { ref, inject, useI18n, useNuxtApp } from '#imports';

const { $i18n } = useNuxtApp();
const order = inject('order');

defineOptions({
    inheritAttrs: false,
});

const error = ref(false);

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            termsAndConditions: 'Hyväksyn Ennakko- ja ryhmätilauksen ehdot.',
            readTerms: 'Lue käyttöehdot',
        },
        'en-EU': {
            text1: 'Maksu tapahtuu paikan päällä.',
            text2: 'Asema on yhteydessä, kun tilaus on käsitelty ja vahvistaa vielä tilauksen',
            termsAndConditions: 'Hyväksyn Ennakko- ja ryhmätilauksen ehdot.',
        },
    },
});

const terms = ref([{
    label: t('termsAndConditions'),
    value: 'terms',
}]);
</script>
<style scoped>
.terms label {
  font-size: 1rem;
  font-weight: 400;
  margin-top: 0.25rem;
}

.terms-link {
  color: var(--color-primary-500);
  text-decoration: underline;
  font-weight: 700;
  position: relative;
  top: -1rem;
  left: 2rem;
}
</style>
